import React, { useEffect, useMemo } from 'react';
import { isEmpty } from 'lodash';
import PLAYER_TYPES from 'constants/player-types';
import Player from 'components/Player';
import MenuContainer from 'containers/Menu';
// import useTimeshiftGuard from './useTimeshiftGuard';

const playerTypesWithEPG = [
  PLAYER_TYPES.CHANNEL,
  PLAYER_TYPES.VOD_CHANNEL,
  PLAYER_TYPES.CATCHUP,
  PLAYER_TYPES.TIMESHIFT,
];

const PlayerPage = (props) => {
  const { playerType, queryParams, isEPGOpen, isPlayedDataLoaded, content } = props;
  const { isDeepLink, loadPlayerData, navigateToFirstAvailableChannel, isLoggedIn, showEPG } = props;
  const isNeedToShowMenu = useMemo(
    () => playerTypesWithEPG.includes(playerType) && !isEPGOpen,
    [playerType, isEPGOpen],
  );
  // DOESNT WORK WELL
  // useTimeshiftGuard(playerType, content);

  useEffect(() => {
    const actions = async () => {
      await loadPlayerData({ params: queryParams, playerType });
      if (playerType === PLAYER_TYPES.CHANNEL && !queryParams.channelId) {
        navigateToFirstAvailableChannel();
      }
    };
    // After update queryParams processing (from location.pathname).
    // We can get an empty "queryParams" object when user leave player.
    // TODO: check it after connected-router removing
    if (!isEmpty(queryParams) && playerType) actions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, playerType]);

  useEffect(() => {
    if (!content && isPlayedDataLoaded && playerTypesWithEPG.includes(playerType)) {
      if (isDeepLink) {
        showEPG();
      } else {
        // TODO: work with bugs
        // navigateToFirstAvailableChannel();
      }
    }
  }, [isPlayedDataLoaded, content, playerType, navigateToFirstAvailableChannel, isDeepLink, showEPG]);

  useEffect(() => {
    if (!isLoggedIn && playerTypesWithEPG.includes(playerType)) showEPG();
  }, [isLoggedIn, playerType, showEPG]);

  // For preventing bugs
  if (!playerType) return null;

  return (
    <>
      {isNeedToShowMenu && <MenuContainer />}
      <Player {...props} />
    </>
  );
};

export default PlayerPage;
